import { styled } from '$utils/theme'
import { Icon } from '$views/components/Icon'
import { rem } from 'polished'
import * as React from 'react'

interface Props {
  background: 'green' | 'grey' | 'yellow' | 'pink'
  center?: boolean
  icon?: string
  onClick?: () => void
  testId?: string
}

const TagWrapper = styled.div<Props>`
  display: flex;
  align-items: ${p => (p.center ? 'center' : 'baseline')};
  justify-content: space-around;
  justify-self: flex-start;

  padding: ${p => `${rem(p.theme.sizes.tiny)} ${rem(p.theme.sizes.base)}`};

  background-color: ${p =>
    p.background === 'green'
      ? p.theme.colors.xlightGreen
      : p.background === 'yellow'
      ? p.theme.colors.lightYellow
      : p.background === 'pink'
      ? p.theme.colors.xlightPink
      : p.theme.colors.lightGrey};
  border-radius: ${p =>
    `calc((${rem(p.theme.sizes.scale(3))} + ${rem(
      p.theme.sizes.base,
    )}) / 2)`}; // ? Font line height + top and bottom padding divided by two

  &:hover {
    cursor: pointer;
  }

  & > ${Icon} {
    display: inline-flex;
    align-items: center;

    width: ${p => rem(p.theme.sizes.small / 2)};
    height: ${p => rem(p.theme.sizes.small / 2)};

    margin-left: ${p => rem(p.theme.sizes.tiny)};
    margin-right: 0;

    & > svg {
      width: unset;
      height: unset;

      & path {
        fill: ${p => (p.background === 'pink' ? p.theme.colors.pink : p.theme.colors.menu)};
      }
    }
  }
`

export const ListTag: React.FC<Props> = ({ background, icon, center, children, onClick, testId }) => {
  return (
    <TagWrapper data-testid={testId} background={background} center={center} onClick={onClick}>
      {children}
      {icon && <Icon content={icon} color={background === 'green' ? 'green' : 'darkGrey'} size="s" />}
    </TagWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/ListTag.tsx